/** @format **/

import { HeaderCheckBoxSelectListElement } from '../../views/lib/search/listTableHeader/HeaderCheckBoxSelectList';
import { useServiceType } from '../lib/hooks/useOperatorType';

export const FeatureVerbTypeMap = {
    ACTIVATE: 1,
    DEACTIVATE: 2,
    MODIFY: 3,
};

export const FeatureVerbType = {
    ACTIVATE: 'activate',
    DEACTIVATE: 'deactivate',
    MODIFY: 'modify',
};

export const FeatureVerbTypes = [
    { name: FeatureVerbType.ACTIVATE, value: FeatureVerbTypeMap.ACTIVATE },
    { name: FeatureVerbType.MODIFY, value: FeatureVerbTypeMap.MODIFY },
    { name: FeatureVerbType.DEACTIVATE, value: FeatureVerbTypeMap.DEACTIVATE },
] as Array<HeaderCheckBoxSelectListElement>;

export const getFeatureVerbName = (verbId: number): string => {
    let verbName = '';
    switch (verbId) {
        case FeatureVerbTypeMap.ACTIVATE:
            return FeatureVerbType.ACTIVATE;
        case FeatureVerbTypeMap.MODIFY:
            return FeatureVerbType.MODIFY;
        case FeatureVerbTypeMap.DEACTIVATE:
            return FeatureVerbType.DEACTIVATE;
        default:
            break;
    }
    return verbName;
};

export class FeatureTypes {
    public nsType: Array<string> = [];

    public operatorType: Array<number> = [];

    constructor(env: any) {
        try {
            this.nsType = JSON.parse(env.REACT_APP_SUPPORT_COMPONENT_TYPE ?? '[]') as Array<string>;
            this.operatorType = JSON.parse(env.REACT_APP_SUPPORT_OPERATOR_TYPE ?? '[-1]') as Array<number>;
        } catch (error) {
            console.log(error);
        }
    }

    public getList(): Array<HeaderCheckBoxSelectListElement> {
        return useServiceType(this);
    }

    public mapToString(id: number): string {
        let type = '';
        const list = useServiceType(this);
        for (let i = 0; i < list.length; i++) {
            if (list[i].value === id) {
                return list[i].name;
            }
        }
        return type;
    }
}
